import { Record } from 'immutable';

const StudentTaskResultRecord = Record({
  completion: undefined,
  sessionId: undefined,
  studentId: undefined,
});

class StudentTaskResult extends StudentTaskResultRecord { }

export default StudentTaskResult;



// WEBPACK FOOTER //
// ./data/StudentTasks/StudentTaskResult/model.js